/* ============================================================
   LASSINI — theme.js  (vanilla, no deps)
   ============================================================ */
(function () {
  'use strict';
  const money = (cents) =>
    (window.Shopify && Shopify.currency ? '' : '') +
    new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {
      style: 'currency',
      currency: (window.LASSINI && window.LASSINI.currency) || 'EUR',
    }).format(cents / 100);

  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const STR = Object.assign(
    { remove: 'Retirer', quantity: 'Quantité', freeShipProgress: '%amount%', freeShipUnlocked: '' },
    (window.LASSINI && window.LASSINI.strings) || {}
  );

  /* ---------- Announcement rotator ---------- */
  function announcement() {
    const items = $$('.announcement__item');
    if (items.length < 2) return;
    let i = 0;
    setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  /* ---------- Header : transparent sur le hero, opaque au scroll ---------- */
  function header() {
    const h = $('[data-header]');
    if (!h || !document.body.classList.contains('template-index')) return;
    if (!h.classList.contains('header--over-enabled')) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      h.classList.toggle('header--over', window.scrollY < 40);
    };
    update();
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  /* ---------- Mobile nav ---------- */
  function mobileNav() {
    const nav = $('[data-mobile-nav]');
    const open = $('[data-burger]');
    const close = $('[data-mobile-close]');
    if (!nav || !open) return;
    const toggle = (state) => {
      nav.classList.toggle('is-open', state);
      document.body.style.overflow = state ? 'hidden' : '';
    };
    open.addEventListener('click', () => toggle(true));
    close && close.addEventListener('click', () => toggle(false));
    $$('a', nav).forEach((a) => a.addEventListener('click', () => toggle(false)));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && toggle(false));
  }

  /* ---------- Cart drawer ---------- */
  const Cart = {
    drawer: null,
    overlay: null,
    threshold: 0,
    init() {
      this.drawer = $('[data-cart-drawer]');
      this.overlay = $('[data-drawer-overlay]');
      if (!this.drawer) return;
      this.threshold = parseInt(this.drawer.dataset.freeShip || '0', 10);
      $$('[data-cart-toggle]').forEach((b) =>
        b.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        })
      );
      $$('[data-cart-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      this.overlay && this.overlay.addEventListener('click', () => this.close());
      document.addEventListener('keydown', (e) => e.key === 'Escape' && this.close());
      this.bindForms();
      this.refresh();
    },
    open() {
      this.drawer.classList.add('is-open');
      this.overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      this.refresh();
    },
    close() {
      this.drawer.classList.remove('is-open');
      this.overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    },
    bindForms() {
      $$('form[action$="/cart/add"], form[action*="/cart/add"]').forEach((form) => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = form.querySelector('[type="submit"]');
          const label = btn && btn.querySelector('[data-btn-label]');
          const original = label ? label.innerHTML : '';
          if (btn) btn.disabled = true;
          if (label) label.textContent = '…';
          try {
            const res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: this.serialize(form) }),
            });
            if (!res.ok) throw new Error('add failed');
            await this.refresh();
            if (btn) btn.disabled = false;
            if (form.dispatchEvent(new CustomEvent('lassini:added', { cancelable: true }))) {
              // no listener handled the label — restore it, then open drawer
              if (label) label.innerHTML = original;
            }
            this.open();
          } catch (err) {
            if (label) label.innerHTML = original;
            if (btn) btn.disabled = false;
            form.submit();
          }
        });
      });
    },
    serialize(form) {
      const data = new FormData(form);
      const id = data.get('id');
      const qty = parseInt(data.get('quantity') || '1', 10);
      const props = {};
      for (const [k, v] of data.entries()) {
        const m = k.match(/^properties\[(.+)\]$/);
        if (m) props[m[1]] = v;
      }
      const item = { id, quantity: qty };
      if (Object.keys(props).length) item.properties = props;
      // bundle: multiple hidden inputs data-bundle-id
      const bundle = form.querySelectorAll('[data-bundle-id]');
      if (bundle.length) return Array.from(bundle).map((b) => ({ id: b.value, quantity: 1 }));
      return [item];
    },
    async change(key, quantity) {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
      const cart = await res.json();
      this.render(cart);
    },
    async refresh() {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    },
    render(cart) {
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('hide', cart.item_count === 0);
      });
      if (!this.drawer) return;
      const list = $('[data-cart-items]', this.drawer);
      const foot = $('[data-cart-foot]', this.drawer);
      const empty = $('[data-cart-empty]', this.drawer);
      const reco = $('[data-cart-reco]', this.drawer);
      if (reco) reco.classList.toggle('hide', cart.item_count === 0);
      if (cart.item_count === 0) {
        list && (list.innerHTML = '');
        empty && empty.classList.remove('hide');
        foot && foot.classList.add('hide');
      } else {
        empty && empty.classList.add('hide');
        foot && foot.classList.remove('hide');
        if (list)
          list.innerHTML = cart.items
            .map(
              (it) => `
          <div class="line-item" data-key="${it.key}">
            <a href="${it.url}"><img src="${it.image ? it.image.replace(/(\.[^.]+)(\?.*)?$/, '_200x250_crop_center$1') : ''}" alt="${it.product_title}" loading="lazy"></a>
            <div>
              <a href="${it.url}" class="line-item__name">${it.product_title}</a>
              ${it.variant_title && it.variant_title !== 'Default Title' ? `<div class="line-item__variant">${it.variant_title}</div>` : ''}
              <div class="qty">
                <button aria-label="−" data-qty-down>&minus;</button>
                <input value="${it.quantity}" data-qty-input inputmode="numeric" aria-label="${STR.quantity}">
                <button aria-label="+" data-qty-up>&plus;</button>
              </div>
              <button class="line-item__remove" data-remove>${STR.remove}</button>
            </div>
            <div class="line-item__price">${money(it.final_line_price)}</div>
          </div>`
            )
            .join('');
        $('[data-cart-subtotal]', this.drawer).textContent = money(cart.total_price);
      }
      // free-ship progress
      const prog = $('[data-cart-progress]', this.drawer);
      if (prog && this.threshold > 0) {
        const remaining = Math.max(this.threshold - cart.total_price, 0);
        const pct = Math.min((cart.total_price / this.threshold) * 100, 100);
        $('[data-cart-progress-fill]', prog).style.right = 100 - pct + '%';
        $('[data-cart-progress-label]', prog).innerHTML =
          remaining === 0
            ? STR.freeShipUnlocked
            : (STR.freeShipProgress || '%amount%').replace('%amount%', '<strong>' + money(remaining) + '</strong>');
      }
      this.bindLineItems();
    },
    bindLineItems() {
      $$('.line-item', this.drawer).forEach((row) => {
        const key = row.dataset.key;
        const input = $('[data-qty-input]', row);
        $('[data-qty-down]', row).onclick = () => this.change(key, Math.max(+input.value - 1, 0));
        $('[data-qty-up]', row).onclick = () => this.change(key, +input.value + 1);
        input.onchange = () => this.change(key, Math.max(parseInt(input.value || '1', 10), 0));
        $('[data-remove]', row).onclick = () => this.change(key, 0);
      });
    },
  };

  /* ---------- PDP: gallery + variants + sticky ATC ---------- */
  function pdp() {
    const root = $('[data-pdp]');
    if (!root) return;

    const scroll = $('[data-pdp-scroll]', root);
    const frames = $$('.pdp__frame', root);
    const dots = $$('[data-pdp-dots] span', root);

    // carousel dots (mobile) + track active frame
    if (frames.length > 1 && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) {
              const i = frames.indexOf(en.target);
              dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
            }
          });
        },
        { root: scroll, threshold: 0.6 }
      );
      frames.forEach((f) => io.observe(f));
    }

    // variant selection
    const data = JSON.parse($('[data-pdp-variants]', root).textContent);
    const form = $('form[action*="/cart/add"]', root);
    const idInput = $('[name="id"]', form);
    const submit = form.querySelector('[type=submit]');
    const priceEl = $('[data-pdp-price]', root);
    const compareEl = $('[data-pdp-compare]', root);
    const savingEl = $('[data-pdp-saving]', root);
    const btnLabel = $('[data-btn-label]', form);
    const stickyPrice = $('[data-sticky-price]');

    function currentOptions() {
      return $$('[data-option-index]', root).map((group) => {
        const checked = group.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function setLabel(text) {
      // keep " · price" suffix on the ATC button
      const p = btnLabel.dataset.price || '';
      btnLabel.innerHTML = p ? text + '  ·  ' + p : text;
    }
    function update() {
      const opts = currentOptions();
      const match = data.find((v) => v.options.every((o, i) => o === opts[i]));
      if (!match) {
        setLabel('Indisponible');
        submit.disabled = true;
        return;
      }
      idInput.value = match.id;
      submit.disabled = !match.available;
      btnLabel.dataset.price = money(match.price);
      setLabel(match.available ? btnLabel.dataset.add : 'Rupture de stock');
      priceEl.textContent = money(match.price);
      if (compareEl) {
        const sale = match.compare_at_price && match.compare_at_price > match.price;
        compareEl.textContent = sale ? money(match.compare_at_price) : '';
        compareEl.classList.toggle('hide', !sale);
        if (savingEl) {
          savingEl.textContent = sale ? 'Économisez ' + money(match.compare_at_price - match.price) : '';
          savingEl.classList.toggle('hide', !sale);
        }
      }
      if (stickyPrice) stickyPrice.textContent = money(match.price);
      // swap gallery to the variant image
      if (match.media_id && scroll) {
        const f = frames.find((x) => x.dataset.mediaId == match.media_id);
        if (f) f.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }
    $$('[data-option-index] input', root).forEach((i) => i.addEventListener('change', update));
    update();

    // ATC success micro-feedback
    form.addEventListener('lassini:added', (e) => {
      e.preventDefault(); // tell Cart we own the label
      btnLabel.textContent = '✓ Ajouté au sac';
      submit.classList.add('is-ok');
      setTimeout(() => { setLabel(btnLabel.dataset.add); submit.classList.remove('is-ok'); }, 1600);
    });

    // sticky ATC visibility
    const sticky = $('[data-sticky-atc]');
    const anchor = $('[data-pdp-buybox]', root);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        ([e]) => sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0),
        { threshold: 0 }
      ).observe(anchor);
      $('[data-sticky-add]', sticky).addEventListener('click', () => submit.click());
    }
  }

  /* ---------- Bundle tiers ---------- */
  function bundle() {
    $$('[data-bundle]').forEach((root) => {
      const tiers = $$('[data-tier]', root);
      const priceOut = $('[data-bundle-price]', root);
      const compareOut = $('[data-bundle-compare]', root);
      const select = (tier) => {
        tiers.forEach((t) => t.classList.toggle('is-active', t === tier));
        priceOut && (priceOut.textContent = tier.dataset.price);
        compareOut && (compareOut.textContent = tier.dataset.compare || '');
        const qtyInput = $('[data-bundle-qty]', root);
        qtyInput && (qtyInput.value = tier.dataset.qty);
      };
      tiers.forEach((t) => t.addEventListener('click', () => select(t)));
      if (tiers[1]) select(tiers[1]);
      else if (tiers[0]) select(tiers[0]);
    });
  }

  /* ---------- Collection filters (client-side, tag based) ---------- */
  function collectionFilters() {
    const bar = $('[data-coll-filters]');
    const grid = $('[data-coll-grid]');
    if (!bar || !grid) return;
    const cards = $$('[data-tags]', grid);
    bar.addEventListener('click', (e) => {
      const chip = e.target.closest('.chip');
      if (!chip) return;
      const pressed = chip.getAttribute('aria-pressed') === 'true';
      $$('.chip', bar).forEach((c) => c.setAttribute('aria-pressed', 'false'));
      chip.setAttribute('aria-pressed', String(!pressed));
      const tag = pressed ? null : chip.dataset.tag;
      cards.forEach((card) => {
        const show = !tag || card.dataset.tags.split('|').includes(tag);
        card.classList.toggle('hide', !show);
      });
    });
    const sort = $('[data-coll-sort]');
    sort &&
      sort.addEventListener('change', () => {
        const items = $$('[data-tags]', grid);
        const dir = sort.value;
        items
          .sort((a, b) => {
            const pa = +a.dataset.price,
              pb = +b.dataset.price;
            if (dir === 'price-asc') return pa - pb;
            if (dir === 'price-desc') return pb - pa;
            return (+a.dataset.pos || 0) - (+b.dataset.pos || 0);
          })
          .forEach((el) => grid.appendChild(el));
      });
  }

  /* ---------- Wishlist (cœur des cartes, local) ---------- */
  function wishlist() {
    const btns = $$('[data-wish]');
    if (!btns.length) return;
    let set;
    try { set = new Set(JSON.parse(localStorage.getItem('lassini_wish') || '[]')); } catch (e) { set = new Set(); }
    const save = () => { try { localStorage.setItem('lassini_wish', JSON.stringify([...set])); } catch (e) {} };
    btns.forEach((b) => {
      const h = b.dataset.wish;
      if (set.has(h)) b.setAttribute('aria-pressed', 'true');
      b.addEventListener('click', (e) => {
        e.preventDefault();
        const on = b.getAttribute('aria-pressed') === 'true';
        b.setAttribute('aria-pressed', String(!on));
        on ? set.delete(h) : set.add(h);
        save();
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function reveal() {
    const els = $$('.reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach((e) => e.classList.add('is-in'));
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((en) => {
          if (en.isIntersecting) {
            en.target.classList.add('is-in');
            io.unobserve(en.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    els.forEach((e) => io.observe(e));
  }

  /* ---------- Shoppable photo ---------- */
  function shoppable() {
    $$('[data-shoppable]').forEach((root) => {
      const spots = $$('[data-hotspot]', root);
      const closeAll = () => spots.forEach((s) => {
        s.classList.remove('is-open');
        s.querySelector('.hotspot__dot').setAttribute('aria-expanded', 'false');
      });
      spots.forEach((spot) => {
        const dot = $('.hotspot__dot', spot);
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          const open = spot.classList.contains('is-open');
          closeAll();
          if (!open) {
            spot.classList.add('is-open');
            dot.setAttribute('aria-expanded', 'true');
            // flip card if it would overflow the right edge
            if (spot.dataset.side === 'auto') {
              const card = $('.hotspot__card', spot);
              spot.classList.remove('flip');
              const r = card.getBoundingClientRect();
              if (r.right > window.innerWidth - 12) spot.classList.add('flip');
            }
          }
        });
        const x = $('[data-hotspot-close]', spot);
        x && x.addEventListener('click', (e) => { e.stopPropagation(); closeAll(); });
      });
      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-hotspot]')) closeAll();
      });
      document.addEventListener('keydown', (e) => e.key === 'Escape' && closeAll());

      // parallax (throttlé via requestAnimationFrame)
      const media = $('[data-shoppable-media]', root);
      if (media && root.dataset.parallax === 'true' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches &&
          window.matchMedia('(pointer: fine)').matches) {
        let raf = 0, px = 0, py = 0;
        const apply = () => { raf = 0; media.style.transform = `translate3d(${px}px, ${py}px, 0)`; };
        root.addEventListener('mousemove', (e) => {
          const r = root.getBoundingClientRect();
          px = ((e.clientX - r.left) / r.width - 0.5) * -18;
          py = ((e.clientY - r.top) / r.height - 0.5) * -18;
          if (!raf) raf = requestAnimationFrame(apply);
        }, { passive: true });
        root.addEventListener('mouseleave', () => {
          if (raf) { cancelAnimationFrame(raf); raf = 0; }
          media.style.transform = '';
        });
      }
    });
  }

  /* ---------- Popup e-mail ---------- */
  function emailPopup() {
    const p = $('[data-popup]');
    if (!p) return;
    if (document.body.classList.contains('template-cart')) return;
    let seen = false;
    try { seen = localStorage.getItem('lassini_popup') === '1'; } catch (e) {}
    if (seen) return;

    const mark = () => { try { localStorage.setItem('lassini_popup', '1'); } catch (e) {} };
    const open = () => {
      if (p.classList.contains('is-open')) return;
      p.hidden = false;
      requestAnimationFrame(() => p.classList.add('is-open'));
      document.body.style.overflow = 'hidden';
      mark();
      clearTimeout(timer);
      document.removeEventListener('mouseout', onExit);
    };
    const close = () => {
      p.classList.remove('is-open');
      document.body.style.overflow = '';
      setTimeout(() => { p.hidden = true; }, 400);
    };

    $$('[data-popup-close]', p).forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => e.key === 'Escape' && p.classList.contains('is-open') && close());
    if ($('[data-popup-success]', p)) { open(); return; } // revient après submit

    const delay = (parseInt(p.dataset.popupDelay, 10) || 18) * 1000;
    const timer = setTimeout(open, delay);
    const onExit = (e) => { if (e.clientY <= 0 && !e.relatedTarget) open(); };
    setTimeout(() => document.addEventListener('mouseout', onExit), 4000);
  }

  /* ---------- Hero : bouton qui défile vers la section suivante ---------- */
  function heroScroll() {
    const b = $('[data-hero-scroll]');
    if (!b) return;
    b.addEventListener('click', () => {
      const hero = $('.hero');
      const start = (hero && hero.closest('.shopify-section')) || hero;
      let t = start && start.nextElementSibling;
      while (t && !t.querySelector('section, .section') && t.tagName !== 'SECTION' && !t.classList.contains('section')) t = t.nextElementSibling;
      const target = t ? (t.querySelector('section, .section') || t) : null;
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      else window.scrollTo({ top: window.innerHeight, behavior: 'smooth' });
    });
  }

  /* ---------- Carrousel (collection vedette mobile) ---------- */
  function rails() {
    $$('[data-rail]').forEach((root) => {
      const track = $('[data-rail-track]', root);
      const dots = $$('[data-rail-dots] span', root);
      if (!track || dots.length < 2 || !('IntersectionObserver' in window)) return;
      const cards = $$('.pcard', track);
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting) {
              const i = cards.indexOf(en.target);
              dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
            }
          });
        },
        { root: track, threshold: 0.6 }
      );
      cards.forEach((c) => io.observe(c));
    });
  }

  /* ---------- Il Codice ---------- */
  function codice() {
    $$('[data-codice]').forEach((root) => {
      const tabs = $$('.codice__item', root);
      const panel = $('#codice-panel', root);
      if (!tabs.length || !panel) return;
      const num = $('[data-panel-num]', panel);
      const title = $('[data-panel-title]', panel);
      const body = $('[data-panel-body]', panel);
      const select = (tab) => {
        tabs.forEach((t) => t.setAttribute('aria-selected', String(t === tab)));
        panel.classList.add('is-swapping');
        setTimeout(() => {
          num.textContent = tab.dataset.num;
          title.textContent = tab.dataset.title;
          body.textContent = tab.dataset.body;
          panel.setAttribute('aria-labelledby', tab.id);
          panel.classList.remove('is-swapping');
        }, 180);
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); tabs[(i + 1) % tabs.length].focus(); tabs[(i + 1) % tabs.length].click(); }
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); tabs[(i - 1 + tabs.length) % tabs.length].focus(); tabs[(i - 1 + tabs.length) % tabs.length].click(); }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    announcement();
    header();
    mobileNav();
    Cart.init();
    pdp();
    bundle();
    collectionFilters();
    wishlist();
    shoppable();
    codice();
    rails();
    heroScroll();
    emailPopup();
    reveal();
  });
})();
